import httpService from "./http.service";

const getHubspotDeal = ({ dealId }) =>
  httpService
    .get(`/hubspot/deals/${dealId}`)
    .then(({ data }) => data)
    .catch((err) => Promise.reject(err.response));

const methods = {
  getHubspotDeal
};

export default methods;
